import DocumentService from '@/Modules/Document/DocumentService.js'

export default class SchemaDocumentService extends DocumentService {
  static resource = 'schemas'
}
